export function Pagination({ page, totalPages, onPrev, onNext }) {
    return (
      <div className="flex justify-center items-center gap-4 mt-6">
        <button
          onClick={onPrev}
          disabled={page === 1}
          className="px-3 py-1 border rounded disabled:opacity-50"
        >
          ← Trang trước
        </button>
        <span>Trang {page} / {totalPages}</span>
        <button
          onClick={onNext}
          disabled={page === totalPages}
          className="px-3 py-1 border rounded disabled:opacity-50"
        >
          Trang sau →
        </button>
      </div>
    );
  }